import { render, staticRenderFns } from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=template&id=74be87c2&"
import script from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=script&lang=js&"
export * from "./EvolutionDashboardDepartmentsSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74be87c2')) {
      api.createRecord('74be87c2', component.options)
    } else {
      api.reload('74be87c2', component.options)
    }
    module.hot.accept("./EvolutionDashboardDepartmentsSelector.vue?vue&type=template&id=74be87c2&", function () {
      api.rerender('74be87c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/EvolutionDashboardDepartmentsSelector.vue"
export default component.exports